<template>
  <div class="clientilist">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Clienti</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" to="/clienti/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Cliente</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="openModalDeleteCliente(row.item)" v-b-tooltip.hover title="Elimina"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button size="sm" style="margin-left: 10px;" :to="'clienti/modifica/'+row.item.id" v-b-tooltip.hover title="Modifica"><font-awesome-icon icon="edit" /></b-button>
              <b-button v-if="row.item.ubicazioni.length > 0" size="sm" variant="primary" style="margin-left: 10px;" v-b-tooltip.hover title="Ubicazioni" v-on:click="openModalListaUbicazioni(row.item)"><font-awesome-icon icon="map-marked-alt" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare <strong>{{modalData.delete.nome}} {{modalData.delete.cognome}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteCliente(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.ubicazione" size="xl" title="Lista ubicazioni del cliente!">
      <b-table
          :striped="true"
          :hover="true"
          :responsive="true"
          :items="modalData.ubicazione"
          :fields="ubicazioni.campi"
          :current-page="ubicazioni.currentPage"
          :per-page="ubicazioni.perPage"
        >

      </b-table>
      <div slot="modal-footer">
        <b-button class="float-right" v-on:click="modal.ubicazione = false">Chiudi</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'clientiadd',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'codice', label: 'Codice', sortable: true},
        {key: 'denominazione', label: 'Denominazione', sortable: true},
        {key: 'cf', label: 'Codice Fiscale', sortable: true},
        {key: 'piva', label: 'P. IVA', sortable: true},
        {key: 'residenza', label: 'Indirizzo Residenza', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,

      ubicazioni: {
        campi: [
          {key: 'indirizzo', label: 'Indirizzo', sortable: true},
          {key: 'referente', label: 'Referente', sortable: true},
          {key: 'cellulare', label: 'Cellulare', sortable: true},
          {key: 'telefono', label: 'Telefono', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'note', label: 'Note', sortable: true}
        ],
        currentPage: 1,
        perPage: 10,
      },
      modal: {
        delete: false,
        ubicazione: false,
      },
      modalData: {
        delete: {},
        ubicazione: [],
      }
    }
  },
  created: function(){
    this.getListaClienti()
  },
  methods: {
    getListaClienti(){
      Vue.http.post('cliente/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.data
            this.totalRows = this.lista.length
        }else{
          this.lista = []
          /*Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista installatori non caricata correttamente.",
              type: 'error'
          })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteCliente(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    openModalListaUbicazioni(item){
      this.modalData.ubicazione = item.ubicazioni.map(e => {
        var x = e.indirizzo.split(",")
        console.log(x[x.length-1].trim().slice(0, 2))
        if(x[x.length-1].trim().slice(0, 2) == "M_")
          e.indirizzo = x.slice(0, x.length-1).join(", ")+", "+x[x.length-1].trim().slice(2)

        return e
      })
      this.ubicazioni.perPage = item.ubicazioni.length
      this.modal.ubicazione = true
    },
    deleteCliente(id){
      Vue.http.post('cliente/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaClienti()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Cliente eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>


<style>
</style>